export default {
  default: {
    button: 'Add Field',
    text: 'No Fields available in this template',
    title: 'Fields',
  },
}
